import { getApiLicensingCheck } from '../api/sdk.gen';

export function LicenseChecker() {
  let hasUserValidLicense = false;

  function getHasUserValidLicense() {
    return hasUserValidLicense;
  }

  async function checkUserLicenseStatus() {
    const { data } = await getApiLicensingCheck();
    hasUserValidLicense = data ?? false;
  }

  return {
    getHasUserValidLicense,
    checkUserLicenseStatus,
  };
}
